<script setup lang="ts">
import { faBriefcase, faHouse } from '@fortawesome/pro-regular-svg-icons';
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { CommonDomainMarktsegment } from '@services/identity-api/orval-api/model/commonDomainMarktsegment';

interface Props {
  huidigMarktsegment?: string;
  marktsegmenten: CommonDomainMarktsegment[];
}

const props = defineProps<Props>();

const emit = defineEmits<{
  select: [marktsegment: CommonDomainMarktsegment];
}>();

function marktsegmentIcon(marktsegment: CommonDomainMarktsegment) {
  return marktsegment === CommonDomainMarktsegment.Zakelijk ? faBriefcase : faHouse;
}
</script>

<template>
  <div class="border-0 border-b border-solid border-grey-200 p-4">
    <div class="text-xs text-grey-400">Wissel van omgeving</div>

    <ul aria-label="Marktsegment" class="mt-3 list-none p-0 text-sm">
      <li
        v-for="marktsegment in props.marktsegmenten"
        :key="marktsegment"
        class="relative -mt-px flex items-center gap-3 border border-solid px-3 py-2 text-primary-900 first:mt-0 first:rounded-t last:rounded-b"
        :class="
          props.huidigMarktsegment === marktsegment
            ? 'z-10 border-primary-400/50 bg-primary-200/50'
            : 'cursor-pointer border-grey-200'
        "
        :aria-current="props.huidigMarktsegment === marktsegment ? 'true' : undefined"
        v-on="
          props.huidigMarktsegment !== marktsegment
            ? { click: () => emit('select', marktsegment) }
            : {}
        "
      >
        <FontAwesomeIcon fixed-width :icon="marktsegmentIcon(marktsegment)" />
        <span class="grow">{{ marktsegment }}</span>
        <FontAwesomeIcon
          v-if="props.huidigMarktsegment === marktsegment"
          class="text-primary"
          :icon="faCheckCircle"
        />
      </li>
    </ul>
  </div>
</template>
